require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-phenomic-reason.json") })
        }
      }, "path---package-phenomic-reason");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-phenomic-reason!./.cache/json/package-phenomic-reason.json
// module id = 879
// module chunks = 231608221292675